// import moment from "moment"
// import React, { useEffect, useState } from "react"
// import IndiaFlag from "../../../assets/images/flags/india.png"
// import UkFlag from "../../../assets/images/flags/uk.png"
// import CanadaFlag from "../../../assets/images/flags/canadian_flag.jpg"
// import creditSafeImg from "../../../assets/images/creditsafe/icon-2.png"
// import secureLocalStorage from "react-secure-storage"
// import axios from "axios"
// import configure from "configure"
// import Loader from "pages/Separate/Loader"
// import { useLocation } from "react-router-dom"
// import { FetchNodePostData } from "utils/common-fetchData"

// const PotentialLeads = ({ junk }) => {
//   const [isLoading, setLoading] = useState(false)
//   const [potential_data, setPotentialData] = useState([])
//   const token = secureLocalStorage.getItem("auth_token")
//   const location = useLocation()

//   const toggleLoading = loading => {
//     setLoading(loading)
//   }

//   useEffect(() => {
//     LeadData()
//   }, [location.pathname])

//   const LeadData = async e => {
//     const formData = new FormData()
//     setLoading(true)
//     try {
//       const bearerToken = secureLocalStorage.getItem("auth_token")
//       const response = await axios({
//         method: "get",
//         url: `${configure.apiUrl}/get_lead_potential`,
//         headers: {
//           Authorization: "Bearer " + bearerToken,
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//         data: formData,
//       })

//       if (junk)
//         setPotentialData(response.data?.data?.filter(i => i.trash == 1) || [])
//       else
//         setPotentialData(
//           response.data?.data?.filter(
//             i => i.trash == 0 && i.isConvertedtoLead == 0
//           ) || []
//         )
//     } catch (err) {
//       console.log(err)
//     } finally {
//       setLoading(false)
//     }
//   }

//   // const onChangeStatus = async lead_id => {
//   //   swal({
//   //     title: "Are you sure?",
//   //     text: "You Want to Change Lead Status !",
//   //     icon: "warning",
//   //     buttons: true,
//   //     dangerMode: true,
//   //   }).then(async willDelete => {
//   //     if (willDelete) {
//   //       setLoading(true)
//   //       const formData = new FormData()
//   //       formData.append("client_id", lead_id)
//   //       try {
//   //         const response = await axios({
//   //           method: "post",
//   //           url: `${configure.apiUrl}/change_statuss`,
//   //           headers: {
//   //             Accept: "application/json",
//   //             "Content-Type": "multipart/form-data",
//   //           },
//   //           data: formData,
//   //         })

//   //         setPotentialData(response.data?.data?.filter(i => i.trash == 0) || [])
//   //         setLoading(false)
//   //       } catch (err) {
//   //         console.log(err)
//   //         setLoading(false)
//   //       }
//   //     }
//   //   })
//   // }

//   const onConvert = async items => {
//     let type = 0;
//     if (junk) {
//       type = 1;
//     }
//     swal({
//       title: "Are you sure?",
//       text: junk ? "Do you want to Revert this to a Potential Lead" : "Do you want to convert this to a lead?",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async willConvert => {
//       if (willConvert) {
//         try {
//           const response = await FetchNodePostData(
//             toggleLoading,
//             `convert/convertToLead/${items.id}/${type}`,
//             token,
//             items
//           )
//           LeadData();

//           if (response?.success || response?.data?.success) {
//             swal({
//               icon: "success",
//               title: "Converted!",
//               text: junk ? "Lead Reverted To Opportunity Lead successfully" : "Lead converted to Leads successfully.",
//             })
//           }
//         } catch (error) {
//           swal({
//             icon: "error",
//             title: "Error",
//             text: "Something went wrong!",
//           })
//         }
//       }
//     })
//   }

//   // Lead Potential
//   // const onRemoveLead = async (id,type) => {
//   //     swal({
//   //         title: "Are you sure?",
//   //         text: "You want to remove this lead from the list!",
//   //         icon: "warning",
//   //         buttons: true,
//   //         dangerMode: true,
//   //     }).then(async willDelete => {
//   //         if (willDelete) {
//   //             setLoading(true);
//   //             try {
//   //                 const bearerToken = secureLocalStorage.getItem("auth_token");
//   //                 const response = await axios({
//   //                     method: "get",
//   //                     url: `${configure.nodeApi}/remove_lead/${id}/${type}`,
//   //                     headers: {
//   //                         Authorization: "Bearer " + bearerToken,
//   //                         Accept: "application/json",
//   //                     },
//   //                 });
//   //                 setPotentialData(response.data?.data?.filter(i => i.trash == 0));
//   //                 swal({
//   //                     title: "Success!",
//   //                     text: "Lead has been successfully removed.",
//   //                     icon: "success",
//   //                 });
//   //             } catch (err) {
//   //                 console.log(err);
//   //                 swal({
//   //                     title: "Error!",
//   //                     text: "Something went wrong while removing the lead.",
//   //                     icon: "error",
//   //                 });
//   //             } finally {
//   //                 setLoading(false);
//   //             }
//   //         }
//   //     });
//   // };

//   //    url: `${configure.nodeApi}/remove_lead/${id}/${type}`,


//   const onRemoveLead = async id => {
//     const type = junk ? 2 : 1;
//     const willDelete = await swal({
//       title: "Are you sure?",
//       text: junk ? "You want to remove this lead from Junk Lead" : "You want to remove this lead and move to Junk Lead",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     })

//     if (!willDelete) return

//     setLoading(true)
//     try {
//       const bearerToken = secureLocalStorage.getItem("auth_token")
//       const response = await axios({
//         method: "post", // consider changing to POST/DELETE
//         url: `${configure.nodeApi}/convert/convert-to/trash/${id}/${type}`,
//         headers: {
//           Authorization: "Bearer " + bearerToken,
//           Accept: "application/json",
//         },
//       })

//       // Update UI if API returns data
//       if (response.data?.data) {
//         setPotentialData(response.data.data.filter(i => i.trash === 0))
//       }
//       LeadData();

//       await swal({
//         title: "Success!",
//         text: junk ? "Lead has been successfully removed." : "Lead has been successfully Moved to junk Leads.",
//         icon: "success",
//       })
//     } catch (err) {
//       console.error(err)
//       await swal({
//         title: "Error!",
//         text: "Something went wrong while removing the lead.",
//         icon: "error",
//       })
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <>
//       {isLoading && <Loader />}
//       <div className="card">
//         <div className="card-body ">
//           <div className="mb-3 text-purple fs-5 mb-0 fw-bold">
//             {junk ? "Junk Leads" : "Opportunity Leads"}{" "}
//           </div>
//           <div className="table-responsive">
//             <table className="table table-bordered mb-0 table">
//               <thead>
//                 <tr>
//                   <th>Lead From</th>
//                   <th>Name</th>
//                   <th>Email</th>
//                   <th style={{ width: "3%" }}>Mobile No.</th>
//                   <th>Industry</th>
//                   <th>Service</th>
//                   <th style={{ width: "13%" }}>Message</th>
//                   <th style={{ width: "5%" }}>Date</th>
//                   <th style={{ width: "8%" }}>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {potential_data?.map((items, i) => {
//                   let backColor
//                   if (items.lead_type == "Hot") {
//                     backColor = "bd-hot-follow"
//                   } else if (items.lead_type == "Cold") {
//                     backColor = "bd-cold"
//                   } else if (items.lead_type == "Warm") {
//                     backColor = "bd-warm"
//                   }

//                   let LeadFrom
//                   if (items.location == 1) {
//                     LeadFrom = (
//                       <div className="d-flex align-items-center justify-content-center">
//                         <img
//                           src={IndiaFlag}
//                           alt="No Img"
//                           className="me-2"
//                           width="20"
//                           height="15"
//                         />
//                         <i
//                           className="fas fa-globe"
//                           style={{
//                             fontSize: "17px",
//                             color: "black",
//                           }}
//                         ></i>
//                       </div>
//                     )
//                   } else if (items.location == 2) {
//                     LeadFrom = (
//                       <div className="d-flex align-items-center justify-content-center">
//                         <img
//                           src={UkFlag}
//                           alt="No Img"
//                           className="me-2"
//                           width="20"
//                           height="15"
//                         />
//                         <i
//                           className="fas fa-globe"
//                           style={{
//                             fontSize: "17px",
//                             color: "black",
//                           }}
//                         ></i>
//                       </div>
//                     )
//                   } else if (items.location == 3) {
//                     LeadFrom = (
//                       <div className="d-flex align-items-center justify-content-center">
//                         <img
//                           src={CanadaFlag}
//                           alt="No Img"
//                           className="me-2"
//                           width="20"
//                           height="15"
//                         />
//                         <i
//                           className="fas fa-globe"
//                           style={{
//                             fontSize: "17px",
//                             color: "black",
//                           }}
//                         ></i>
//                       </div>
//                     )
//                   } else if (items.location == 11) {
//                     LeadFrom = (
//                       <div className="d-flex align-items-center justify-content-center">
//                         <i
//                           className="fas fa-utensils text-success me-2"
//                           style={{ fontSize: "17px" }}
//                         ></i>
//                         <i
//                           className="fas fa-globe"
//                           style={{
//                             fontSize: "17px",
//                             color: "black",
//                           }}
//                         ></i>
//                       </div>
//                     )
//                   } else if (items.location == 12) {
//                     LeadFrom = (
//                       <div className="d-flex align-items-center justify-content-center">
//                         <img
//                           src={UkFlag}
//                           alt="No Img"
//                           className="me-2"
//                           width="20"
//                           height="15"
//                         />
//                         <img
//                           src={creditSafeImg}
//                           title="creditSafe"
//                           alt="No Img"
//                           className=""
//                           width="20"
//                           height="15"
//                         />
//                       </div>
//                     )
//                   }

//                   if (localStorage.getItem("auth_id") == 140) {
//                     if (items.location == 11) {
//                       return (
//                         <tr key={i} className={backColor}>
//                           <td>{LeadFrom}</td>
//                           <td scope="row">{items.name}</td>
//                           <td>{items.email}</td>
//                           <td>{items.contact}</td>
//                           <td>
//                             {items.industry != null ? items.industry : "-"}
//                           </td>
//                           <td>{items.service != null ? items.service : "-"}</td>
//                           <td>{items.message != null ? items.message : "-"}</td>
//                           <td>
//                             {moment(items.created_at).format(
//                               "DD-MM-YYYY hh:mm:ss"
//                             )}
//                           </td>

//                           <td className="text-center">

//                             <a
//                               className="btn btn-sm me-1 btn-outline-primary"
//                               title={junk ? "Revert To Opportunity Lead" : "Convert To Lead"}
//                               onClick={() => onConvert(items)}
//                             >
//                               <i className="bi bi-arrow-clockwise"></i>
//                             </a>

//                             {/* <a
//                                                                 title="view lead"
//                                                                 className="btn btn-sm btn-outline-secondary me-1"
//                                                                 onClick={() => onChangeStatus(items.id)}
//                                                             >
//                                                                 <i className="fas fa-check"></i>
//                                                             </a> */}
//                             <a
//                               className="btn btn-sm me-1 btn-outline-danger"
//                               title="Trash Lead"
//                               onClick={() => onRemoveLead(items?.id)}
//                             >
//                               <i className="bi bi-trash"></i>
//                             </a>
//                           </td>
//                         </tr>
//                       )
//                     }
//                   } else {
//                     return (
//                       <tr key={i} className={backColor}>
//                         <td>{LeadFrom}</td>
//                         <td scope="row">{items.name}</td>
//                         <td>{items.email}</td>
//                         <td>{items.contact}</td>
//                         <td>{items.industry != null ? items.industry : "-"}</td>
//                         <td>{items.service != null ? items.service : "-"}</td>
//                         <td>{items.message != null ? items.message : "-"}</td>
//                         <td>
//                           {moment(items.created_at).format(
//                             "DD-MM-YYYY hh:mm:ss"
//                           )}
//                         </td>
//                         <td className="text-center">

//                           <a
//                             className="btn btn-sm me-1 btn-outline-primary"
//                             title={junk ? "Revert To Opportunity Lead" : "Convert To Lead"}
//                             onClick={() => onConvert(items)}
//                           >
//                             <i className="bi bi-arrow-clockwise"></i>
//                           </a>

//                           {/* <a
//                                                             title="view lead"
//                                                             className="btn btn-sm btn-outline-secondary me-1"
//                                                             onClick={onChangeStatus}
//                                                         >
//                                                             <i className="fas fa-check"></i>
//                                                         </a> */}
//                           <a
//                             className="btn btn-sm me-1 btn-outline-danger"
//                             title="Trash Lead"
//                             onClick={() => onRemoveLead(items?.id)}
//                           >
//                             <i className="bi bi-trash"></i>
//                           </a>
//                         </td>
//                       </tr>
//                     )
//                   }
//                 })}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default PotentialLeads


import moment from "moment"
import React, { useEffect, useState } from "react"
import IndiaFlag from "../../../assets/images/flags/india.png"
import UkFlag from "../../../assets/images/flags/uk.png"
import creditSafeImg from "../../../assets/images/creditsafe/icon-2.png"
import CanadaFlag from "../../../assets/images/flags/canadian_flag.jpg"
import secureLocalStorage from "react-secure-storage"
import axios from "axios"
import configure from "configure"
import Loader from "pages/Separate/Loader"
import { useLocation } from "react-router-dom"
import Swal from "sweetalert2"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import { Form, Row, Col } from "reactstrap"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import { useMemo } from "react"
import Pagination from "components/Common/Pagination"


const PotentialLeads = ({ junk }) => {
  const [isLoading, setLoading] = useState(false)
  const [potential_data, setPotentialData] = useState([])

  const [formPopup, setFormPopup] = useState(false)
  const [fullLeadLoading, setFullLeadLoading] = useState(false)

  // Filter states
  const [fName, setFName] = useState("")
  const [fEmail, setFEmail] = useState("")
  const [fIndustry, setFIndustry] = useState("")
  const [fService, setFService] = useState("")

  const token = secureLocalStorage.getItem("auth_token")
  const location = useLocation()

  const toggleLoading = loading => {
    setLoading(loading)
  }

  const columns = useMemo(
    () => [
      { Header: "Lead From", accessor: "location" },
      { Header: "Name", accessor: "name" },
      { Header: "Email", accessor: "email" },
      { Header: "Mobile No.", accessor: "contact" },
      { Header: "Industry", accessor: "industry" },
      { Header: "Service", accessor: "service" },
      { Header: "Message", accessor: "message" },
      { Header: "Date", accessor: "created_at" },
      { Header: "Action", accessor: "id" },
    ],
    []
  )

  const { 
    page,
    prepareRow,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
  } = useTable(
    { columns, data: potential_data, initialState: { pageSize: 25 } },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  useEffect(() => {
    LeadData()
  }, [location.pathname])

  const LeadData = async e => {
    const formData = new FormData()
    setLoading(true)
    try {
      const bearerToken = secureLocalStorage.getItem("auth_token")
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/get_lead_potential`,
        headers: {
          Authorization: "Bearer " + bearerToken,
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      })

      if (junk)
        setPotentialData(response.data?.data?.filter(i => i.trash == 1) || [])
      else
        setPotentialData(
          response.data?.data?.filter(
            i => i.trash == 0 && i.isConvertedtoLead == 0
          ) || []
        )
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  // const onChangeStatus = async lead_id => {
  //   swal({
  //     title: "Are you sure?",
  //     text: "You Want to Change Lead Status !",
  //     icon: "warning",
  //     buttons: true,
  //     dangerMode: true,
  //   }).then(async willDelete => {
  //     if (willDelete) {
  //       setLoading(true)
  //       const formData = new FormData()
  //       formData.append("client_id", lead_id)
  //       try {
  //         const response = await axios({
  //           method: "post",
  //           url: `${configure.apiUrl}/change_statuss`,
  //           headers: {
  //             Accept: "application/json",
  //             "Content-Type": "multipart/form-data",
  //           },
  //           data: formData,
  //         })

  //         setPotentialData(response.data?.data?.filter(i => i.trash == 0) || [])
  //         setLoading(false)
  //       } catch (err) {
  //         console.log(err)
  //         setLoading(false)
  //       }
  //     }
  //   })
  // }

  const onConvert = async items => {
    console.log("items", items)
    let type = 0
    if (junk) {
      type = 1
    }
    console.log("TYpeeeeeeee", type)
    swal({
      title: "Are you sure?",
      text: junk
        ? "Do you want to Revert this to a Potential Lead"
        : "Do you want to convert this to a lead?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willConvert => {
      if (willConvert) {
        try {
          const response = await FetchNodePostData(
            toggleLoading,
            `convert/convertToLead/${items.id}/${type}`,
            token,
            items
          )
          LeadData()

          if (response?.success || response?.data?.success) {
            swal({
              icon: "success",
              title: "Converted!",
              text: junk
                ? "Lead Reverted To Opportunity Lead successfully"
                : "Lead converted to Leads successfully.",
            })
          }
        } catch (error) {
          swal({
            icon: "error",
            title: "Error",
            text: "Something went wrong!",
          })
        }
      }
    })
  }

  // Lead Potential
  // const onRemoveLead = async (id,type) => {
  //     swal({
  //         title: "Are you sure?",
  //         text: "You want to remove this lead from the list!",
  //         icon: "warning",
  //         buttons: true,
  //         dangerMode: true,
  //     }).then(async willDelete => {
  //         if (willDelete) {
  //             setLoading(true);
  //             try {
  //                 const bearerToken = secureLocalStorage.getItem("auth_token");
  //                 const response = await axios({
  //                     method: "get",
  //                     url: `${configure.nodeApi}/remove_lead/${id}/${type}`,
  //                     headers: {
  //                         Authorization: "Bearer " + bearerToken,
  //                         Accept: "application/json",
  //                     },
  //                 });
  //                 setPotentialData(response.data?.data?.filter(i => i.trash == 0));
  //                 swal({
  //                     title: "Success!",
  //                     text: "Lead has been successfully removed.",
  //                     icon: "success",
  //                 });
  //             } catch (err) {
  //                 console.log(err);
  //                 swal({
  //                     title: "Error!",
  //                     text: "Something went wrong while removing the lead.",
  //                     icon: "error",
  //                 });
  //             } finally {
  //                 setLoading(false);
  //             }
  //         }
  //     });
  // };

  //    url: `${configure.nodeApi}/remove_lead/${id}/${type}`,

  const onRemoveLead = async id => {
    const type = junk ? 2 : 1
    const willDelete = await swal({
      title: "Are you sure?",
      text: junk
        ? "You want to remove this lead from Junk Lead"
        : "You want to remove this lead and move to Junk Lead",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })

    if (!willDelete) return

    setLoading(true)
    try {
      const bearerToken = secureLocalStorage.getItem("auth_token")
      const response = await axios({
        method: "post", // consider changing to POST/DELETE
        url: `${configure.nodeApi}/convert/convert-to/trash/${id}/${type}`,
        headers: {
          Authorization: "Bearer " + bearerToken,
          Accept: "application/json",
        },
      })

      // Update UI if API returns data
      if (response.data?.data) {
        setPotentialData(response.data.data.filter(i => i.trash === 0))
      }
      LeadData()

      await swal({
        title: "Success!",
        text: junk
          ? "Lead has been successfully removed."
          : "Lead has been successfully Moved to junk Leads.",
        icon: "success",
      })
    } catch (err) {
      console.error(err)
      await swal({
        title: "Error!",
        text: "Something went wrong while removing the lead.",
        icon: "error",
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      <div className="card">
        <div className="card-body ">
          <div className="mb-3 text-purple fs-5 mb-0 fw-bold">
            {junk ? "Junk Leads" : "Opportunity Leads"}{" "}
          </div>
          <Row className="mb-2">
            <Col xs="auto d-flex align-items-center">
              <div className="d-flex">
                <select
                  className="form-select"
                  style={{ width: "100px" }}
                  value={pageSize}
                  onChange={e => setPageSize(Number(e.target.value))}
                >
                  {[10, 25, 50, 100].map(size => (
                    <option key={size} value={size}>
                      Show {size}
                    </option>
                  ))}
                </select>
              </div>
            </Col>
            <Col className="d-flex justify-content-end">
            <div className="search-box">
                  <div className="position-relative">
                    <label htmlFor="search-bar-0" className="search-label">
                      <span id="search-bar-0-label" className="sr-only">
                        Search this table
                      </span>
                      <input
                        onChange={e => setGlobalFilter(e.target.value)}
                        value={globalFilter || ""}
                        id="search-bar-0"
                        type="text"
                        className="form-control rounded h-100"
                        placeholder={
                          fullLeadLoading
                            ? "Loading search engine..."
                            : "Search..."
                        }
                      />
                    </label>
                    <i className="bx bx-search-alt search-icon"></i>
                  </div>
                  </div>
              {/* <div>
                <button
                  onClick={() => setFormPopup(!formPopup)}
                  className="btn btn-outline-secondary  me-3"
                >
                  <i className="fas fa-filter"></i>
                </button>
              </div> */}
            </Col>
          </Row>
          <div className="table-responsive">
            <table className="table table-bordered mb-0 table">
              <thead>
                <tr>
                  <th>Lead From</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th style={{ width: "3%" }}>Mobile No.</th>
                  <th>Industry</th>
                  <th>Service</th>
                  <th style={{ width: "13%" }}>Message</th>
                  <th style={{ width: "5%" }}>Date</th>
                  <th style={{ width: "8%" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {page.map((row, i) => {
                  prepareRow(row)
                  const items = row.original
                  let backColor
                  if (items.lead_type == "Hot") {
                    backColor = "bd-hot-follow"
                  } else if (items.lead_type == "Cold") {
                    backColor = "bd-cold"
                  } else if (items.lead_type == "Warm") {
                    backColor = "bd-warm"
                  }

                  let LeadFrom
                  if (items.location == 1) {
                    LeadFrom = (
                      <div className="d-flex align-items-center justify-content-center">
                        <img
                          src={IndiaFlag}
                          alt="No Img"
                          className="me-2"
                          width="20"
                          height="15"
                        />
                        <i
                          className="fas fa-globe"
                          style={{
                            fontSize: "17px",
                            color: "black",
                          }}
                        ></i>
                      </div>
                    )
                  } else if (items.location == 2) {
                    LeadFrom = (
                      <div className="d-flex align-items-center justify-content-center">
                        <img
                          src={UkFlag}
                          alt="No Img"
                          className="me-2"
                          width="20"
                          height="15"
                        />
                        <i
                          className="fas fa-globe"
                          style={{
                            fontSize: "17px",
                            color: "black",
                          }}
                        ></i>
                      </div>
                    )
                  } else if (items.location == 3) {
                    LeadFrom = (
                      <div className="d-flex align-items-center justify-content-center">
                        <img
                          src={CanadaFlag}
                          alt="No Img"
                          className="me-2"
                          width="20"
                          height="15"
                        />
                        <i
                          className="fas fa-globe"
                          style={{
                            fontSize: "17px",
                            color: "black",
                          }}
                        ></i>
                      </div>
                    )
                  } else if (items.location == 11) {
                    LeadFrom = (
                      <div className="d-flex align-items-center justify-content-center">
                        <i
                          className="fas fa-utensils text-success me-2"
                          style={{ fontSize: "17px" }}
                        ></i>
                        <i
                          className="fas fa-globe"
                          style={{
                            fontSize: "17px",
                            color: "black",
                          }}
                        ></i>
                      </div>
                    )
                  } else if (items.location == 12) {
                    LeadFrom = (
                      <div className="d-flex align-items-center justify-content-center">
                        <img
                          src={UkFlag}
                          alt="No Img"
                          className="me-2"
                          width="20"
                          height="15"
                        />
                        <img
                          src={creditSafeImg}
                          title="creditSafe"
                          alt="No Img"
                          className=""
                          width="20"
                          height="15"
                        />
                      </div>
                    )
                  }

                  if (localStorage.getItem("auth_id") == 140) {
                    if (items.location == 11) {
                      return (
                        <tr key={i} className={backColor}>
                          <td>{LeadFrom}</td>
                          <td scope="row">{items.name}</td>
                          <td>{items.email}</td>
                          <td>{items.contact}</td>
                          <td>
                            {items.industry != null ? items.industry : "-"}
                          </td>
                          <td>{items.service != null ? items.service : "-"}</td>
                          <td>{items.message != null ? items.message : "-"}</td>
                          <td>
                            {moment(items.created_at).format(
                              "DD-MM-YYYY hh:mm:ss"
                            )}
                          </td>

                          <td className="text-center">
                            <a
                              className="btn btn-sm me-1 btn-outline-primary"
                              title={
                                junk
                                  ? "Revert To Opportunity Lead"
                                  : "Convert To Lead"
                              }
                              onClick={() => onConvert(items)}
                            >
                              <i className="bi bi-arrow-clockwise"></i>
                            </a>

                            {/* <a
                                                                title="view lead"
                                                                className="btn btn-sm btn-outline-secondary me-1"
                                                                onClick={() => onChangeStatus(items.id)}
                                                            >
                                                                <i className="fas fa-check"></i>
                                                            </a> */}
                            <a
                              className="btn btn-sm me-1 btn-outline-danger"
                              title="Trash Lead"
                              onClick={() => onRemoveLead(items?.id)}
                            >
                              <i className="bi bi-trash"></i>
                            </a>
                          </td>
                        </tr>
                      )
                    }
                  } else {
                    return (
                      <tr key={i} className={backColor}>
                        <td>{LeadFrom}</td>
                        <td scope="row">{items.name}</td>
                        <td>{items.email}</td>
                        <td>{items.contact}</td>
                        <td>{items.industry != null ? items.industry : "-"}</td>
                        <td>{items.service != null ? items.service : "-"}</td>
                        <td>{items.message != null ? items.message : "-"}</td>
                        <td>
                          {moment(items.created_at).format(
                            "DD-MM-YYYY hh:mm:ss"
                          )}
                        </td>
                        <td className="text-center">
                          <a
                            className="btn btn-sm me-1 btn-outline-primary"
                            title={
                              junk
                                ? "Revert To Opportunity Lead"
                                : "Convert To Lead"
                            }
                            onClick={() => onConvert(items)}
                          >
                            <i className="bi bi-arrow-clockwise"></i>
                          </a>

                          {/* <a
                                                            title="view lead"
                                                            className="btn btn-sm btn-outline-secondary me-1"
                                                            onClick={onChangeStatus}
                                                        >
                                                            <i className="fas fa-check"></i>
                                                        </a> */}
                          <a
                            className="btn btn-sm me-1 btn-outline-danger"
                            title="Trash Lead"
                            onClick={() => onRemoveLead(items?.id)}
                          >
                            <i className="bi bi-trash"></i>
                          </a>
                        </td>
                      </tr>
                    )
                  }
                })}
              </tbody>
            </table>
          </div>

          {/* {formPopup ? (
            <div className="popup-form p-4">
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  setCurrentPage(1)
                  setFormPopup(false)
                }}
              >
                <Row className="align-items-end">
                  <Row className="d-flex pe-0 me-0" style={{ width: "100%" }}>
                    <div className="col-md-3 mb-2">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={fName}
                        onChange={e => setFName(e.target.value)}
                        placeholder="Search name"
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      <label>Email</label>
                      <input
                        type="text"
                        className="form-control"
                        value={fEmail}
                        onChange={e => setFEmail(e.target.value)}
                        placeholder="Search email"
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      <label>Industry</label>
                      <input
                        type="text"
                        className="form-control"
                        value={fIndustry}
                        onChange={e => setFIndustry(e.target.value)}
                        placeholder="Search industry"
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      <label>Service</label>
                      <input
                        type="text"
                        className="form-control"
                        value={fService}
                        onChange={e => setFService(e.target.value)}
                        placeholder="Search service"
                      />
                    </div>
                    <div className="d-flex col-md-12 align-items-end justify-content-end mt-2">
                      <button className="btn btn-purple mr-10">
                        <i className="fas fa-filter search-icon me-1 icon-center"></i>{" "}
                        Filter
                      </button>
                      <a
                        className="btn mr-10"
                        onClick={onClearFilter}
                        style={{
                          backgroundColor: "#fed36d",
                          borderColor: "#fed36d",
                          color: "black",
                        }}
                      >
                        Clear Filters
                      </a>
                      <a
                        className="btn btn-red"
                        onClick={() => setFormPopup(false)}
                      >
                        <i className="dripicons-cross me-1 icon-center"></i>{" "}
                        Close
                      </a>
                    </div>
                  </Row>
                </Row>
              </Form>
              <i className="bi bi-triangle-fill pop-icon"></i>
            </div>
          ) : null} */}

          <Row className="justify-content-md-end justify-content-center align-items-center mt-2">
            <Pagination
              gotoPage={gotoPage}
              previousPage={previousPage}
              canPreviousPage={canPreviousPage}
              nextPage={nextPage}
              canNextPage={canNextPage}
              pageIndex={pageIndex}
              pageOptions={pageOptions}
            />
          </Row>
        </div>
      </div>
    </>
  )
}

export default PotentialLeads